import { Plugin } from 'ckeditor5/src/core';
import CleanPasteEditing from './cleanpasteediting';

/**
 * The clean paste plugin.
 *
 * This plugin cleans pasted content to prevent style contamination,
 * focusing on removing external font families, colors, and background colors
 * while preserving content structure.
 */
export default class CleanPaste extends Plugin {
	/**
	 * @inheritDoc
	 */
	public static get requires() {
		return [ CleanPasteEditing ] as const;
	}

	/**
	 * @inheritDoc
	 */
	public static get pluginName() {
		return 'CleanPaste' as const;
	}
}
